import { Team, TeamMember, PaginatedResponse } from "@/types";
import { apiClient } from "@/lib/apiClient";

/**
 * Team Service
 * Handles all team-related API calls
 */
export const teamApi = {
  /**
   * Get all teams for current user's company
   */
  getAll: async (): Promise<PaginatedResponse<Team>> => {
    return apiClient.get<PaginatedResponse<Team>>("/api/teams");
  },


  /**
   * Create a new team
   */
  create: async (data: { name: string; description?: string }): Promise<Team> => {
    return apiClient.post<Team>("/api/teams", data);
  },

  /**
   * Update existing team
   */
  update: async (
    teamId: string,
    data: { name: string; description?: string }
  ): Promise<Team> => {
    return apiClient.put<Team>(`/api/teams/${teamId}`, data);
  },

  /**
   * Delete a team
   */
  delete: async (teamId: string): Promise<void> => {
    return apiClient.delete<void>(`/api/teams/${teamId}`);
  },
};

/**
 * Team Member Service
 * Handles team membership operations
 */
export const teamMemberApi = {
  /**
   * Get all members of a team
   */
  getMembers: async (teamPid: string): Promise<PaginatedResponse<TeamMember>> => {
    return apiClient.get<PaginatedResponse<TeamMember>>(`/api/teams/${teamPid}/members`);
  },

  /**
   * Add a member to a team
   */
  add: async (teamPid: string, userId: string): Promise<TeamMember> => {
    return apiClient.post<TeamMember>(`/api/teams/${teamPid}/members`, { userPid: userId });    
  },

  /**
   * Remove a member from a team
   */
  remove: async (teamPid: string, userPid: string): Promise<void> => {
    return apiClient.delete<void>(`/api/teams/${teamPid}/members/${userPid}`);
  },
};
